import { trackEvent } from './track-event'

type Selection = {
  amount: number
  name: string
}

type TrackCtaSelectionPayload = {
  type: 'experience' | 'accommodation'
  selection: string | Selection[]
}

type Action = 'take over - persons' | 'show room details' | 'take over - option'

export function trackCtaSelection(action: Action, payload: TrackCtaSelectionPayload) {
  const selection = Array.isArray(payload.selection)
    ? payload.selection.map(s => `${s.amount}x${s.name}`).join('|')
    : payload.selection

  trackEvent({
    event: 'click_cta_selection',
    event_name: 'user_interaction',
    type: payload.type,
    action: `click - ${action}`,
    selection,
  })
}
